import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import QueryingStudyProcedureRunFlowchart from 'studies/typed/shared/unit-op-linking-flowchart/StudyProcedureRunFlowchart';

import VisualizationState from './VisualizationState';

export default class VisualizationView extends Backbone.View<VisualizationState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override initialize(): void {
    this.listenTo(this.model, 'change', () => this.render());
  }

  override render(): this {
    const id = this.model.get('studyId');
    renderToDOM(<QueryingStudyProcedureRunFlowchart studyId={id} />, this.el);
    return this;
  }

  override remove(): Backbone.View<VisualizationState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

VisualizationView.initClass();
